export default {
    currentSubStep: 0,
    furthestSubStep: 0,
    useEnroleeBillingAddress: true,
    showLegalGuardian1: false,
    showLegalGuardian2: false,
    showApprenticeshipSupervisor: true,
    numberOfOptionalDocuments: 0,
    uploadDocuments: true,
    uploadLegalGuardianForm: true,
    useBillingAddressLegalGuardian1: false,
    useBillingAddressLegalGuardian2: false,
    radioTagGroups: {},
};
